import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalStateAll: [],
  generalState: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalStateSlice = createSlice({
  name: "generalState",
  initialState,
  reducers: {
    setGeneralStateAll: (state, action) => {
      state.generalStateAll = action.payload;
    },
    setGeneralState: (state, action) => {
      state.generalState = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralStateAll,
  setGeneralState,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalStateSlice.actions;

export default generalStateSlice.reducer;
